import { Pipe, PipeTransform } from '@angular/core'

import {TaskDifficulty} from './../'

@Pipe({name: 'difficultyLabel'})

export class DifficultyLabelPipe implements PipeTransform {

  private static difficultyLabels = {
    0 : 'General',
    1 : 'Easier',
    2 : 'Harder',
    3 : 'Unknown',
    4 : 'Moderate',
  }

  transform(difficultyValue: number): string {
    return DifficultyLabelPipe.difficultyLabels[difficultyValue] || ''
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/pipes/difficulty-label.pipe.ts